module.exports = __webpack_public_path__ + "static/media/CoheteChooseContent.24aacb55.png";